import service from "./fetchInterceptor";

/**
 * Obtiene la lista de transferencias de vehículos
 */
export function getCartransfers(limit, page, filters, sortBy = "repertory:desc", q) {
  return service.get(`/cartransfers`, {
    params: {
      limit,
      page,
      sortBy,
      ...(filters && { ...filters }),
      ...(q && { q }),
    },
  });
}

/**
 * Obtiene una transferencia por ID
 */
export function getCartransfer(id) {
  return service.get(`/cartransfers/${id}`);
}

/**
 * Actualiza una transferencia
 */
export function setCartransfer(id, data) {
  return service.patch(`/cartransfers/${id}`, data);
}

/**
 * Crea una transferencia
 */
export function addCartransfer(data) {
  return service.post("/cartransfers", data);
}

/**
 * Elimina una transferencia
 */
export function removeCartransfer(id) {
  return service.delete(`/cartransfers/${id}`);
}

/**
 * Realiza el pago de una transferencia
 */
export function pay(data) {
  return service.post("/cartransfers/pay", data);
}

/**
 * Realiza el pago de una transferencia con timeout extendido para captcha
 */
export function payWithExtendedTimeout(data) {
  return service.post("/cartransfers/pay", data, {
    timeout: 300000, // 5 minutos para el proceso de captcha
  });
}

/**
 * Genera carpeta para una transferencia
 */
export function generateFolder(cartransferId) {
  return service.post(`/cartransfers/folder/generate/${cartransferId}`);
}

/**
 * Genera movimientos para una transferencia
 */
export function generateMovements(cartransferId) {
  return service.post(`/cartransfers/movements/${cartransferId}`);
}

/**
 * Obtiene dashboard de transferencias
 */
export function getDashboard(month) {
  return service.get(`/cartransfers/dashboard`, {
    params: { month },
  });
}

/**
 * Obtiene estadísticas por tipo de vehículo
 */
export function getVehicleTypeStats(month) {
  return service.get(`/cartransfers/vehicle-stats`, {
    params: { month },
  });
}
